import React, { Component } from 'react';
import FiltersComponent from "./filters-component";
import {connect} from "react-redux";
import {
  cleanFilters, deleteFilter, loadFiltersLimbo, loadFiltersRequest, reloadData, toggleFilter,
  toggleIsScore
} from "./filters-action-creators";
import {loadResponsesRequest} from "../responses/responses-action-creators";
import {loadHbIndexChartDataRequest} from "../hb-index-chart/hb-index-chart-action-creators";

class FiltersContainer extends Component {

  componentDidMount() {
    const { whoMounted, reportUrl, loadFilters, loadFiltersLimbo } = this.props;
    whoMounted !== reportUrl ? loadFilters(reportUrl) : loadFiltersLimbo();
  }

  componentWillUnmount() {
    this.props.cleanFilters()
  }

  render() {
    return <FiltersComponent {...this.props} />
  }
}

const mapStateToProps = state => ({
  whoMounted: state.filters.whoMounted,
  filters: state.filters.filters,
  loading: state.filters.loading,
  error: state.filters.error,
  reportUrl: state.report.reportUrl,
  responsesLoading: state.charts.topWordsLoading,
  responsesAfter: state.charts.responsesInfo.responsesAfter,
  responsesTotal: state.charts.responsesInfo.responsesTotal,
  responsesInfoError: state.charts.responsesInfoError,
  hbIndex: state.charts.hbIndex,
  hbIndexLoading: state.charts.sentimentBreakdownLoading,
  hbIndexError: state.charts.hbIndexError
});


const mapDispatchToProps = dispatch => ({
  loadFilters: reportUrl => dispatch(loadFiltersRequest(reportUrl)),
  toggleFilter: ({ filterIndex, containerIndex, all }) => {
    dispatch(toggleFilter({filterIndex, containerIndex, all}));
    dispatch(reloadData());
  },
  deleteFilter: index => {
    dispatch(deleteFilter(index));
    dispatch(reloadData());
  },
  toggleIsScore: filterIndex => {
    dispatch(toggleIsScore(filterIndex));
    dispatch(loadResponsesRequest({page: 1, clean: true}));
    dispatch(loadHbIndexChartDataRequest())
  },
  cleanFilters: () => dispatch(cleanFilters()),
  loadFiltersLimbo: () => dispatch(loadFiltersLimbo())
});

export default connect(mapStateToProps, mapDispatchToProps)(FiltersContainer);


// WEBPACK FOOTER //
// ./src/modules/filters/filters-container.js